import { Package, Globe, LucideIcon } from "lucide-react";

interface TypeBadgeConfig {
  style: string;
  icon: LucideIcon;
  label: string;
}

const TYPE_BADGE_CONFIG: Record<string, TypeBadgeConfig> = {
  physical: {
    style: "bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400",
    icon: Package,
    label: "Physical",
  },
  virtual: {
    style:
      "bg-purple-50 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400",
    icon: Globe,
    label: "Virtual",
  },
};

export function getProductTypeBadgeConfig(type: string): TypeBadgeConfig {
  return TYPE_BADGE_CONFIG[type] || TYPE_BADGE_CONFIG.physical;
}
